export default __webpack_public_path__ + "static/media/p4.f7ab1d44.jpg";